<div>
  <ng-container [formGroup]="formArray">
    <ng-container *ngFor="let textControl of formArray.controls; let i = index">
      <div class="sender-ids-form__container">
        <mat-form-field appearance="fill" class="sender-ids-form__form-field">
          <mat-label>Sender ID</mat-label>
            <mat-icon
              matTooltip="Sender IDs must be 3 to 11 characters long."
              matTooltipPosition="above"
              class="sender-ids-form__help-icon"
            >
              info
            </mat-icon> 

          <textarea
            matInput
            cdkTextareaAutosize
            [formControl]="textControl"
            #autosize="cdkTextareaAutosize"
            cdkAutosizeMinRows="1"
            cdkAutosizeMaxRows="10"
            class="sender-ids-form__text-input"
          ></textarea>

          @if (i) {
            <button mat-icon-button matSuffix aria-label="delete" type="button" (click)="handleDeleteTextField($event, i)">
              <mat-icon>delete</mat-icon>
            </button>
          }
          <mat-error>{{ getErrorMessage(textControl) }}</mat-error>
        </mat-form-field>

        <button 
          matTooltip="your 3rd Party can let you know which OPA they use"
          matTooltipPosition="above"
          class="sender-ids-form__third_party_button button--secondary"
          mat-raised-button
          type="button"
          (click)="handleThirdParties(i)"
        >
          Assign 3rd Party
          <mat-icon>info</mat-icon>
        </button>
      </div>
      <mat-chip-set aria-label="Third Parties" class="sender-ids-form__chips">
        @for (thirdParty of selectedThirdParties[i]; track $index) {
          <mat-chip [disableRipple]="true">{{ thirdParty }}</mat-chip>
        }
      </mat-chip-set>
    </ng-container>
  </ng-container>

  <div class="sender-ids-form__add-button">
    <button mat-raised-button (click)="addNewTextField()" [disabled]="!canAddNewTextField">Add Another Sender ID</button>
    <mat-error class="sender-ids-form__form-error-message" *ngIf="getFormErrorMessage(); let formError">
      {{ formError }}
    </mat-error>
  </div>
</div>
